import { resetSearchStore } from '../actions/internalActions';
import { defaultSearchStore, getStore } from '../store/store';
import { map } from 'mobx';
import { mutator } from 'satcheljs';
export default mutator(resetSearchStore, function () {
    var searchStore = getStore();
    // Reset store to defaults.
    searchStore.currentSearchQueryId = defaultSearchStore.currentSearchQueryId;
    searchStore.currentSuggestions = defaultSearchStore.currentSuggestions;
    searchStore.latestQFRequestId = defaultSearchStore.latestQFRequestId;
    searchStore.latestTraceId = defaultSearchStore.latestTraceId;
    searchStore.nextSearchQueryId = defaultSearchStore.nextSearchQueryId;
    searchStore.searchSessionGuid = defaultSearchStore.searchSessionGuid;
    searchStore.searchText = defaultSearchStore.searchText;
    searchStore.searchTextForSuggestion = defaultSearchStore.searchTextForSuggestion;
    searchStore.selectedSuggestionIndex = defaultSearchStore.selectedSuggestionIndex;
    searchStore.suggestedSearchTerm = defaultSearchStore.suggestedSearchTerm;
    searchStore.suggestionPillIds = defaultSearchStore.suggestionPillIds;
    searchStore.suggestionPills = map();
});
//# sourceMappingURL=resetSearchStoreMutator.js.map